"use strict";const t=()=>{let e=document.activeElement;for(;e&&e.shadowRoot&&e.shadowRoot.activeElement;)e=e.shadowRoot.activeElement;return e};export default t;
//# sourceMappingURL=getActiveElement.js.map
